/**
 * Duck para pegar o serviço de Selo
 * @author Otávio Bastilho
 * @copyright 11/2019
 */

import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    conciliationSeal: {}
});

/**
 * Handlers
 */
const INITIAL_STATE = {};

const conciliationSeal = (state = INITIAL_STATE, action) => {
	const newState = { ...state };
	newState.conciliationSeal = action.payload;
	return newState.conciliationSeal;
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
	[Types.CONCILIATION_SEAL]: conciliationSeal
});
